<template>
    <div class="pv4 ba tc bg-white" style="width: 375px;">
        <img class="w3 pb4" :src="image"/>
        <div class="ph4 pb4">
            <h5>{{title}}</h5>
            <div v-if="description" class="mt3">{{description}}</div>
        </div>
        <div class="ph3">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        image: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: null
        }
    }
};
</script>
